<div style="min-height: 800px;" *ngIf="!resultLoaded">

</div>
<div *ngIf="resultLoaded">
<header class="header-auto header-blog">
    <div class="container-m">
      <div class="button-wrapper b-properites">
        <a (click)="backToList()" style="cursor: pointer;" class="button-back-to text-default w-inline-block"><img src=" ../../assets/images/Gruppe-811.svg" loading="lazy" width="16" alt="" class="image arrow-left">
          <div>Back to all</div>
        </a>
        <button (click)="goToContact()" class="button button-primary w-button">GET IN TOUCH</button>
      </div>
      <div class="content-wrapper b-10px">
        <div class="guides-publishing-content">
          <div class="blog-time-wrapper">
            <p class="text-blog text-default">{{property.type == 'Sales' ? 'Buy' : 'Rent'}}</p>
          </div>
          <p class="text-blog text-default">•</p>
          <div class="blog-category-wrapper">
            <p class="text-blog text-primary">{{property.locationDetails.area}}</p>
          </div>
        </div>
      </div>
      <div class="content-wrapper">
        <div class="h2 text-default">{{property.propertyTitle}}</div>
      </div>
    </div>
    <div class="bg-section bg-background"></div>
  </header>
  <section class="section standard t-0px">
    <div class="container-m">
      <a (click)="openImageDialog()" style="cursor: pointer;" class="image title-image w-inline-block w-lightbox"><img src="{{propertyTitleImageUri}}" loading="lazy" alt="" class="image title-image">
        <div class="image-button"><img src="{{propertyTitleImageUri}}" loading="lazy" width="34" alt="" class="image-button-icon">
          <div>All images</div>
        </div>
      </a>
      <div class="collection-list-wrapper-hide w-dyn-list">
        <div role="list" class="w-dyn-items">
          <div role="listitem" class="w-dyn-item">
            <a href="#" class="image title-image w-inline-block w-dyn-bind-empty w-lightbox"><img src="" loading="lazy" alt="" class="image title-image">
              <div class="image-button"><img src=" ../../assets/images/Gruppe-859.svg" loading="lazy" width="34" alt="" class="image-button-icon">
                <div>All images</div>
              </div>
            </a>
          </div>
        </div>
        <div class="w-dyn-empty">
          <div>No items found.</div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-background">
      <div class="bg-section-inner h-properties"></div>
    </div>
  </section>
  <section class="section standard t-0px">
    <div class="container-m">
      <div class="w-layout-grid grid _4er-properties-details">
        <div class="grid-item">
          <div data-w-id="d50275cc-c990-d814-cb6c-b09ee26d3d57"  class="content-wrapper">
            <div class="text-topline text-primary">Price</div>
            <div class="h6 t-properties t-15px w-dyn-bind-empty"></div>
            <div class="h6 t-properties t-15px">{{property.currencyName}} {{property.propertyPrice}} {{property.type == 'Rent' ? '(' + property.rentPaymentMode + ')' : ''}}</div>
          </div>
        </div>
        <div class="grid-item">
          <div data-w-id="f405ffb8-e688-0c6b-514d-a612496added"  class="content-wrapper">
            <div class="text-topline text-primary">Bedrooms</div>
            <div class="h6 t-properties t-15px">{{property.bedroomCount}}</div>
          </div>
        </div>
        <div class="grid-item">
          <div data-w-id="caf16a5d-ef10-1943-834b-5ae5e74fc189"  class="content-wrapper">
            <div class="text-topline text-primary">bathrooms</div>
            <div class="h6 t-properties t-15px t-inline">{{property.bathroomCount}}</div>
            <div class="h6 t-properties t-inline l-4px"></div>
          </div>
        </div>
        <div class="grid-item">
          <div data-w-id="a6ec10db-97ca-15be-cf1e-980335e394cf"  class="content-wrapper">
            <div class="text-topline text-primary">Area</div>
            <div class="h6 t-properties t-15px">{{property.propertySize}}</div>
          </div>
        </div>
      </div>
      <div data-w-id="88c55ab8-3aaa-792b-a2d0-205c6d55d6f3"  class="linie space-property"></div>
      <div class="w-layout-grid grid _2er-properties-description">
        <div class="grid-item">
          <div data-w-id="bdce51cf-32ec-69b8-930f-292d68b7122e"  class="content-wrapper">
            <div class="text-topline text-primary">Property description<br>‍<br> </div>
            <h1><strong>OVERVIEW</strong></h1>
            <div class="rich-text-block t-20px w-richtext" [innerHTML]="property.description"></div>
          </div>
        </div>
        <div id="w-node-_67f72184-fd40-ece7-8a55-fe679cbed0f6-62a9927d" class="grid-item">
          <a data-w-id="cf5befd9-4164-7679-0504-3644f3f7390b" style="cursor: pointer;" (click)="goToContact()" class="sales-agent-link w-inline-block">
            <div class="sales-agent-image"><img src="{{property.propertyAgent.userProfilePictureUri}}" loading="lazy" alt="" class="image full-screen"></div>
            <div class="sales-agent-content">
              <h5 class="h6 text-background">{{property.propertyAgent.userName}}</h5>
              <div class="sales-agent-button">
                <div class="stauts-icon"><img src=" ../../assets/images/Pfad-4727.svg" loading="lazy" width="10" alt="" class="sold-image"></div>
                <div class="agent-text">Send message</div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="bg-section bg-light"></div>
  </section>
  <section class="section standard bg-light">
    <div class="container-m">
      <div class="content-wrapper max-70p l-center">
        <div data-w-id="4497059c-a42e-ae8e-b1ed-c7701729d99a"  class="topline-wrapper b-30px c-center">
          <div class="topline-line bg-primary c-center t-0px"></div>
        </div>
        <h4 data-w-id="4497059c-a42e-ae8e-b1ed-c7701729d99c"  class="h3 text-background l-center">Amenities &amp; Features</h4>
      </div>
      <div class="w-layout-grid grid _4er-properties-details">
        <div class="grid-item">
          <div data-w-id="a95b38d1-a8c3-4b28-42f9-5cdf68b13a19"  class="content-wrapper">
            <div class="text-topline text-primary">Details</div>
            <div class="text-topline text-supline">PROPERTY ID</div>
            <div class="h6 t-properties text-background">{{property.propertyCode}}</div>
            <div class="text-topline text-supline">PROPERTY TYPE</div>
            <div class="h6 t-properties text-background">{{property.categoryName}}</div>
            <div class="text-topline text-supline">Status</div>
            <div class="h6 t-properties text-background">{{property.statusName}}</div>
          </div>
        </div>
        <div class="grid-item">
          <div data-w-id="e198e1f0-4b01-e794-a813-1d973111b041"  class="content-wrapper">
            <div class="text-topline text-primary">Indoor</div>
            <div *ngFor="let amenity of indoorAmenities" class="text-topline text-supline">{{amenity.amenityName}}</div>
          </div>
        </div>
        <div class="grid-item">
          <div data-w-id="e198e1f0-4b01-e794-a813-1d973111b041"  class="content-wrapper">
            <div class="text-topline text-primary">Outdoor</div>
            <div *ngFor="let amenity of outdoorAmenities" class="text-topline text-supline">{{amenity.amenityName}}</div>
          </div>
        </div>
        <div class="grid-item">
          <div data-w-id="e198e1f0-4b01-e794-a813-1d973111b041"  class="content-wrapper">
            <div class="text-topline text-primary">Other</div>
            <div *ngFor="let amenity of otherAmenities" class="text-topline text-supline">{{amenity.amenityName}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-dark bg-rounded-top"><img src=" ../../assets/images/Gruppe-maskieren-64.svg" loading="lazy" alt="" class="image full-screen"></div>
  </section>
  <!-- <section class="section s-google">
    <a data-w-id="82ef5566-f02d-ab1c-caac-2cac3d04d2e5"  href="why-dubai.html" class="box-google w-inline-block">
      <div class="flex-wrapper">
        <div class="box-content b-15px">
          <h4 class="h3 l-center text-background">Why dubai</h4>
          <div class="text-small l-center text-background">Dubai is a city that is constantly thriving. Discover the different opportunities that this mesmerizing city has to offer.</div>
        </div>
        <div class="box-content">
          <div class="button-wrapper l-center">
            <div class="button-plus"><img src=" ../../assets/images/Gruppe-717.svg" loading="lazy" alt="" class="icon h-16px"></div>
          </div>
        </div>
      </div><img src=" ../../assets/images/Gruppe-maskieren-60.svg" loading="lazy" alt="" class="image full-screen">
    </a>
    <div class="bg-section bg-background bg-rounded-bottom">
      <div class="maps w-embed w-iframe"><iframe width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen="" src="">
        </iframe></div>
    </div>
  </section> -->
  <section class="section standard">
    <div class="container-m">
      <div class="w-layout-grid grid _2er-properties-contact">
        <div class="grid-item">
          <div class="content-wrapper">
            <h4 data-w-id="e0bb3cc6-afb7-14ce-c4c0-8d3f7c35408c"  class="h4">Contact person</h4>
            <div class="w-layout-grid grid _2er-contact-person">
              <div class="grid-item">
                <div data-w-id="72b109d0-b983-f4ee-2ae7-173aaf16956b"  class="image-wrapper"><img src="{{property.propertyAgent.userProfilePictureUri}}" loading="lazy" alt="" class="image-contact-person"></div>
              </div>
              <div data-w-id="78f8b143-24e0-3db0-5bd1-bb6ed1b0a80d"  class="grid-item">
                <h4 class="h5 max-60p">{{property.propertyAgent.userName}}</h4>
                <div class="position-text-agent text-primary w-dyn-bind-empty"></div>
                <div class="contact-person-content">
                  <a href="mailto:{{property.propertyAgent.userEmail}}?subject=Hello%20HUDSON" class="link-contact text-default">{{property.propertyAgent.userEmail}}</a>
                  <a href="tel:{{property.propertyAgent.userPhone}}" class="link-contact text-default">{{property.propertyAgent.userPhone}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-item">
          <div data-w-id="8d2947b4-3379-efad-6f95-ba38bab4f427"  class="form-box bg-light">
            <div class="content-wrapper i-80px">
              <h4 class="h4">Contact Sales</h4>
            </div>
            <div class="form-block-normal t-30px w-form">
              <div class="html-embed w-embed">
              </div>
              <!-- <form method="post" data-name="Contact" id="wf-form-Contact" name="wf-form-Contact" class="form" data-wf-page-id="615ea8ddc2e6612f62a9927d" data-wf-element-id="8d2947b4-3379-efad-6f95-ba38bab4f42d"> -->
                <div class="w-layout-grid grid _2er-form-demo">
                  <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f42f-62a9927d" class="grid-item"><input class="input w-input" maxlength="256" name="First-Name" data-name="First Name" placeholder="First name" type="text" id="First_name" required [(ngModel)]="inquiryData.customerDetails.firstName"></div>
                  <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f431-62a9927d" class="grid-item"><input class="input w-input" maxlength="256" name="Last-Name-2" data-name="Last Name 2" placeholder="Last Name" type="text" id="Last-Name-2" [(ngModel)]="inquiryData.customerDetails.lastName"></div>
                  <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f433-62a9927d" class="grid-item"><input class="input w-input" maxlength="256" name="Email-2" data-name="Email 2" placeholder="Email" type="email" id="Email-2" [(ngModel)]="inquiryData.customerDetails.email"></div>
                  <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f435-62a9927d" class="grid-item"><input class="input w-input" maxlength="256" name="Phone-2" data-name="Phone 2" placeholder="Phone" type="tel" id="Phone-2" [(ngModel)]="inquiryData.customerDetails.phoneNo"></div>
                  <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f437-62a9927d" class="grid-item"><textarea placeholder="Message" maxlength="5000" id="field-2" name="field-2" data-name="Field 2" class="text-area w-input" [(ngModel)]="inquiryData.propertyDetails.inquiryDetail"></textarea></div>
                  <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f439-62a9927d" class="grid-item"><label class="w-checkbox checkbox-label t-10px"><input type="checkbox" id="checkbox-2" name="checkbox-2" data-name="Checkbox 2" [(ngModel)]="isAgreeTermServiceCheck" class="w-checkbox-input checkbox-hudson"><span class="text-xsmall text-default w-form-label" for="checkbox-2">I agree to the Terms of Service and Privacy Policy</span></label></div>
                  <div id="w-node-_8d2947b4-3379-efad-6f95-ba38bab4f43e-62a9927d" class="grid-item">
                    <button [ngClass]="{'btn-disable':!isContactFormValid()}" (click)="savePropertyInquiry()" class="button button-primary button-full-width button-form w-button">Connect with us</button>
                  </div>
                </div>
              <!-- </form> -->
              <div class="form__success" *ngIf="isContactSubmitted">
                <div class="h3">Thank you!</div>
                <p class="text-big">We have received your request and will process it as soon as possible.</p>
              </div>
              <div class="form__error w-form-fail">
                <div class="form__error-bg"></div>
                <div class="form__error-text">Oops! Something went wrong while submitting the form.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-background"></div>
  </section>
  <section class="section standard">
    <div class="container-m">
      <div class="content-wrapper max-70p l-center">
        <div data-w-id="e8fd15d8-3c3b-68e2-5ece-f52f89547b09"  class="topline-wrapper b-30px c-center">
          <div class="topline-line bg-primary c-center t-0px"></div>
        </div>
        <h4 data-w-id="e8fd15d8-3c3b-68e2-5ece-f52f89547b0d"  class="h2 l-center">More Properties</h4>
      </div>
      <div class="buy-wrapper">
        <div class="collection-list-wrapper t-40px w-dyn-list">
            <div role="list" class="collection-list filter-complex w-dyn-items">
                <div *ngFor="let otherProperty of property.otherProperties" role="listitem" class="collection-list-item w-dyn-item">
                  <a data-w-id="85de7378-ad14-8fe6-f649-6def91719cfc" [routerLink]="['/propertydetail', otherProperty.id]" class="collection-list-content w-inline-block">
                    <div class="image-wrapper h-200px"><img src="{{otherProperty.propertyTitleImageUrl}}" loading="lazy" alt="" class="image full-screen">
                      <div class="tag bg-dark">
                        <div class="text-block text-background">NEW</div>
                      </div>
                    </div>
                    <div class="box status-normal">
                      <div class="orga">
                        <h5 class="h5 status-h">{{otherProperty?.propertyTitle}}</h5>
                        <p class="text-xsmall b-15px">{{otherProperty?.propertyLocationArea}}</p>
                      </div>
                      <div class="orga">
                        <div class="annual-wrapper">
                          <div class="status-price">{{otherProperty?.propertyPriceCurrency}} {{otherProperty?.propertyPrice}}</div>
                        </div>
                        <div class="line-status"></div>
                        <div class="properties-wrapper">
                          <div class="properties-content">
                            <div class="bedroom-wrapper">
                              <p class="text-details text-default w-dyn-bind-empty"></p>
                              <p class="text-details text-default l-5px">{{otherProperty?.bedroomCount}} Bedrooms</p>
                            </div>
                            <p class="text-details text-default">•</p>
                            <div class="bathroom-wrapper">
                              <p class="text-details text-default w-dyn-bind-empty"></p>
                              <p class="text-details text-default l-5px">{{otherProperty?.bathroomCount}} Bathrooms</p>
                            </div>
                          </div>
                          <div class="status-button l-10px">
                            <div class="stauts-icon"><img src="../../assets/images/Pfad-4727.svg" loading="lazy" width="10" alt="" class="sold-image"></div>
                            <div class="details-text">Details</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="filters-hide">
                      <div class="color w-dyn-bind-empty"></div>
                      <div class="services w-dyn-bind-empty"></div>
                    </div>
                  </a>
                </div>
              </div>
        </div>
      </div>
    </div>
    </section>
</div>